import { PreloadedQuery } from 'react-relay';

import { PROJECT_DIRECTORY_ARCHIVED_PAGE } from '@townsquare/config/routes';
import {
	FAVORITE_VIEWS_COUNT,
	FAVORITE_VIEWS_FAVOURITED_SORT,
	favoriteViewsTqlQuery,
} from '@townsquare/directory-header/resources/directory-favorite-views';
import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import ProjectDirectoryQuery, {
	ProjectDirectoryQuery as ProjectDirectoryQueryType,
} from '../components/__generated__/ProjectDirectoryQuery.graphql';

export const projectDirectoryResource: RouteResource<
	PreloadedQuery<ProjectDirectoryQueryType, Record<string, unknown>>
> = createRelayResource<ProjectDirectoryQueryType>({
	resourceType: 'PROJECT_DIRECTORY_PAGE_RESOURCE',
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		return {
			query: ProjectDirectoryQuery,
			variables: {
				aaid: context.user?.accountId,
				workspaceId: context.workspace?.globalId,
				workspaceUuid: context.workspace?.UUID ?? '',
				containerId: context.collabContext?.contextId,
				includeArchived: routerContext.route.name === PROJECT_DIRECTORY_ARCHIVED_PAGE,
				favouriteViewsTql: context.user ? favoriteViewsTqlQuery(context.user, 'PROJECT') : '',
				favouriteViewsFirst: FAVORITE_VIEWS_COUNT,
				favouriteViewsSort: FAVORITE_VIEWS_FAVOURITED_SORT,
			},
		};
	},
});
